// Defaults
import React, { useMemo } from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { FindifyLoadingScreen } from "../genericPages/components/FindifyLoadingScreen";
import { useAppRoutes } from "../genericPages/hooks/useAppRoutes";

// Custom Pages
import { PlaceTab } from "./PlaceTab";
import { SchedulePage } from "./SchedulePage";
import { PlaceContentListTab } from "./PlaceContentsList";
import { ScanTab } from "../place/hometabs/ScanTab";

const Stack = createNativeStackNavigator();


export const EventsApp = () => {
    const overrides = useMemo(() => [
        // ENTRY PAGE
        { path: "Place", component: PlaceTab },
        // Stack
        { path: "PlaceContentList", component: PlaceContentListTab },
        // ScanPages
        { path: "Scan", component: ScanTab },
        // SchedulePage
        { path: "SchedulePage", component: SchedulePage },
    ], []);

    const { lodadedInitialData, placeRoutes } = useAppRoutes(overrides);

    if (!lodadedInitialData) return <FindifyLoadingScreen />

    return <Stack.Navigator
        screenOptions={{
            animation: 'fade',
            animationTypeForReplace: 'pop',
            animationDuration: 100,
            headerShown: false,
        }}
    >
        {placeRoutes.map((route: any) => {
            return <Stack.Screen key={route.path} name={route.path} component={route.component} />
        })}
    </Stack.Navigator>;
}